import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface RejectSkuLoansRequest {
  token: string;
  skuIds: string[];
}

const rejectSkuLoans = async ({ token, skuIds }: RejectSkuLoansRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-application/pm-reject-invalid-po-sku-loan-applications`,
      { skuIds },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default rejectSkuLoans;
